import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { sendRequest } from "../../helpers/ajax";
import ILicenseKeyChangeIsActiveRequest from "../../types/ILicenseKeyChangeIsActiveRequest";
import ILicenseKeyEditMaster from "../../types/ILicenseKeyEditMaster";
import IResponse from "../../types/IResponse";
import LicenseKeyEdit from "./LicenseKeyEdit";

interface ILicenseKeyEditContainerState {
    clientDetailID: number;
    loading: boolean;
    licenseKey: ILicenseKeyEditMaster;
}

class LicenseKeyEditContainer extends React.Component<RouteComponentProps<any>, ILicenseKeyEditContainerState> {

    constructor(props: RouteComponentProps<any>) {
        super(props);

        this.state = {
            clientDetailID: this.props.match.params.clientDetailID ? this.props.match.params.clientDetailID : 0,
            loading: false,
            licenseKey: {
                keyName: "",
                postbackAuthHeader: "",
                clientDetailID: 0,
                isActive: true,
                licenseKey: ""
            }
        };

        this.loadLicenseKey = this.loadLicenseKey.bind(this);
        this.saveLicenseKey = this.saveLicenseKey.bind(this);
        this.toggleLicenseKeyStatus = this.toggleLicenseKeyStatus.bind(this);
    }

    public async componentDidMount() {
        if (this.state.clientDetailID) {
            this.loadLicenseKey();
        }
    }

    public render() {
        return (
            <LicenseKeyEdit loading={this.state.loading}
                licenseKey={this.state.licenseKey}
                saveLicenseKey={this.saveLicenseKey}
                toggleLicenseKeyStatus={this.toggleLicenseKeyStatus} />
        );
    }

    private async saveLicenseKey(licenseKey: ILicenseKeyEditMaster): Promise<IResponse<ILicenseKeyEditMaster> | null> {

        this.setState({ loading: true });
        const response = await sendRequest<IResponse<ILicenseKeyEditMaster>>("/api/licenseKey/save", "POST", licenseKey);
        this.setState({ loading: false });

        if (response && response.success && response.payload) {
            this.setState({ clientDetailID: response.payload.clientDetailID, licenseKey: response.payload });
        }

        return response;
    }

    private async loadLicenseKey() {
        this.setState({ loading: true });
        const response = await sendRequest<IResponse<ILicenseKeyEditMaster>>(`/api/licenseKey/getById/${this.state.clientDetailID}`, "GET");
        this.setState({ loading: false });

        if (response && response.success) {
            this.setState({ licenseKey: response.payload });
        }
    }

    private async toggleLicenseKeyStatus(status: boolean) {
        this.setState({ loading: true });

        const request: ILicenseKeyChangeIsActiveRequest = {
            clientDetailID: this.state.clientDetailID,
            isActive: status,
        };
        const response = await sendRequest<IResponse<ILicenseKeyEditMaster>>("/api/licenseKey/ChangeLicenseKeyIsActive", "POST", request);

        this.setState({ loading: false });

        if (response && response.success) {
            this.setState({ licenseKey: response.payload });
        }
    }
}

export default withRouter(LicenseKeyEditContainer);



// WEBPACK FOOTER //
// ./src/components/LicenseKeyEdit/LicenseKeyEditContainer.tsx